import React from 'react';
//import { connectStateResults } from 'react-instantsearch/connectors';
import * as icon from '../images/star-crown.png';

class NotFound extends React.Component {
  render(){
    const { query } = this.props;
    return (
      <section className="search-results search-results--not-found">
        <img src={icon} className="star-icon" alt="star crown icon" />
        <p className="message">No results found for <span className="search-results__term">"{query}"</span></p>
      </section>
    )
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js